// extracted by mini-css-extract-plugin
module.exports = {"container":"antd-pro-components-uploader-single-container","isDisabled":"antd-pro-components-uploader-single-isDisabled"};